import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericFormArrayComponent } from 'src/app/shared/components/generic-form-array/generic-form-array.component';
import { AnswerOptionItem } from 'src/app/models/answerOptionItem.model';
import { AnswerOptionItemInputComponent } from '../autocomplete-question/component/answer-option-item-input/answer-option-item-input.component';
import { OptionsList } from 'src/app/models/optionsList.model';
import { UuidService } from 'src/app/services/uuid.service';
import { DragStore } from 'src/app/store/drag-store';
import { debounceTime, tap } from 'rxjs';

@Component({
    selector: 'que-save-name-list',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ReactiveFormsModule, GenericFormArrayComponent, AnswerOptionItemInputComponent],
    templateUrl: './save-name-list.component.html',
    styleUrls: ['./save-name-list.component.scss'],
    providers: [DragStore],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveNameListComponent {
  #uuidService = inject(UuidService);
  isDuplicateQuestionnairePopup = false;
  isCreateCollectionQuestionPopup = false;
  isSavedList = true;
  isDuplicateListPopup = false;
  editList?: OptionsList;
  withItems?: boolean = false;
  #builder = inject(FormBuilder);
  listForm = this.#builder.group({
    guid: new FormControl<string>(this.#uuidService.generateUUID(), [Validators.required]),
    name: new FormControl<string>("", [Validators.required]),
    answerOptionItem: new FormControl<AnswerOptionItem[]>([]),
    isPublic: new FormControl<boolean>(false),
  });
  questionnaireName = new FormControl<string>("");
  listName = new FormControl<string>("");
  newItemIndex = -1;
  isCreate = false;

  previousName = "";
  showMaxLengthError = false;

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: { withItems: boolean, editList?: OptionsList, isDuplicateQuestionnairePopup: boolean, listName: string, isDuplicateListPopup: boolean, name: string, isCreateCollectionQuestionPopup: boolean, isCreate?: boolean }, private readonly dialogRef: MatDialogRef<SaveNameListComponent>) {
    dialogRef.disableClose = true;
    this.withItems = data?.withItems;
    if (data && data.isDuplicateQuestionnairePopup) {
      this.isDuplicateQuestionnairePopup = true;
      this.isSavedList = false
    }
    if (data?.isCreate) {
      this.isCreate = true;
    }
    if (data && data.isCreateCollectionQuestionPopup) {
      this.isCreateCollectionQuestionPopup = true;
      this.isSavedList = false
    }
    if (data && data.name) {
      this.questionnaireName.setValue(data.name)
      this.previousName = data.name;
    }
    if (data && data.isDuplicateListPopup) {
      this.isDuplicateListPopup = true;
      this.isSavedList = false
    }
    if (data && data.listName) {
      this.listName.setValue(data.listName)
    }
    if (data?.editList) {
      this.editList = data.editList;
      this.listForm.patchValue(this.editList)
    }
    else {
      //create new list
      if (this.withItems) {
        this.listForm.controls.isPublic.setValue(true);
      }
    }

    this.questionnaireName.valueChanges.pipe(
      tap(n => {
        if ((n?.length ?? 0) > 70) {
          this.questionnaireName.setValue(this.previousName, { emitEvent: false });
          this.showMaxLengthError = true;
        }
        else {
          this.showMaxLengthError = false;
          this.previousName = n ?? '';
        }
      }),
      debounceTime(500))
      .subscribe(x => {
        this.showMaxLengthError = false;
      });

  }


 

  cancel() {
    this.dialogRef.close();
  }
  save() {
    if (this.isDuplicateQuestionnairePopup || this.isCreateCollectionQuestionPopup) {
      this.dialogRef.close(this.questionnaireName.value);
    }
    else if (this.isDuplicateListPopup) {
      this.dialogRef.close(this.listName.value);
    }
    else {
      this.dialogRef.close({ ...this.listForm.value });
    }
  }
  setNewId(index: number) {
    this.newItemIndex = index + 1;
  }
  newItem() {
    return { guid: this.#uuidService.generateUUID(), name: '', optionsListGuid: this.listForm.controls.guid.value ,isNew:true};
  }
  isEnableSave() {
    if (this.isDuplicateQuestionnairePopup || this.isCreateCollectionQuestionPopup) {
      return this.questionnaireName.value != null && this.questionnaireName.value != "";
    }
    else {
      return ((this.listForm.controls.answerOptionItem.value?.length ?? 0) > 0 || !this.withItems) && this.listForm.controls.name.value != null && this.listForm.controls.name.value != "";
    }
  }
}
